<div class="update-canned-service-dialog">
  <div class="update-canned-service-dialog-header flex-between-center">
    <p class="m-0">
      <i class="fal fa-ballot-check"></i>
      Update canned services and flat rate items
      <span class="m-0 font-bold">{{part.title}}</span>
    </p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="closeDialog(null)"></i>
    </span>
  </div>

  <div class="update-canned-service-dialog-body">
    <div class="assign-list-content flex-column">

      <tr class="assign-list-header flex-start-center">
        <th class="service-checkbox font-600 m-0 px-2">
          <app-checkbox [fontSize]="12" [isChecked]="isAllServiceSelected" (appChange)="handleAllSelect($event)">
          </app-checkbox>
        </th>
        <th class="service-title font-600 m-0 px-2">Item name</th>
        <th class="service-description font-600 m-0 px-2">Description</th>
        <th class="service-next font-600 m-0 px-2">Taxable</th>
        <th class="service-unit-cost font-600 m-0 px-2">Unit Cost</th>
        <th class="service-next font-600 m-0 px-2 text-right">Price</th>
        <!-- <th class="service-next font-600 m-0 px-2">Has&nbsp;Core</th> -->
        <th class="service-next font-600 m-0 px-2 text-right">Core&nbsp;Cost</th>
        <th class="service-next font-600 m-0 px-2 text-right">Qty/Hrs</th>
        <th class="service-next font-600 m-0 px-2 text-right">Subtotal</th>
      </tr>

      <tr class="assign-list-body flex-start-center" *ngFor="let service of cannedServices">

        <!--Checkbox-->
        <td class="service-checkbox font-13 m-0 px-2">
          <app-checkbox [fontSize]="12" [isChecked]="service.isUpdateCannedService"
            (appChange)="handleCheckBox(service?._id, $event)">
          </app-checkbox>
        </td>

        <!-- Title -->
        <td class="service-title text-truncate font-13 m-0 px-2">
          <div class="display-flex">{{itemTypeOption[service.itemType]}}<div class="text-truncate pl-2">
              {{service.title}}</div>
          </div>
        </td>

        <!-- Description -->
        <td class="service-description text-truncate font-13 m-0 px-2">
          <div tooltipStyleClass="assign-tooltip" tooltipPosition="top" [pTooltip]="showToolTip('description')"
            [escape]="false" [tooltipDisabled]="service.description === part.description">
            <span class="text-ellipsis" [class.is-updated]="isFieldUpdated('description')"
              [class.elipses]="service.description != ' '">{{service.description}}</span>
          </div>
        </td>

        <!-- Is Taxable -->
        <td class="service-next text-truncate font-13 m-0 px-2">
          <div tooltipStyleClass="assign-tooltip" tooltipPosition="top" [pTooltip]="showToolTip('isTaxable')"
            [escape]="false" [tooltipDisabled]="service.isTaxable === part.isTaxable">
            <span [class.is-updated]="isFieldUpdated('isTaxable')">{{renderFieldData(service, 'isTaxable')}}</span>
          </div>
        </td>

        <!-- unit cost -->
        <td class="service-unit-cost text-truncate font-13 m-0 px-2">
          <div tooltipStyleClass="assign-tooltip" tooltipPosition="top" [pTooltip]="showToolTip('costRate')"
            [escape]="false" [tooltipDisabled]="service.cost === part.costRate">
            <span [class.is-updated]="isFieldUpdated('costRate')">
              {{['flatRate','service'].includes(service.itemType) ? (renderFieldData(service, 'cost') | currency: usd) : '-'}}
            </span>
          </div>
        </td>

        <!-- Price -->
        <td class="service-next text-truncate font-13 m-0 px-2 text-right">
          <div tooltipStyleClass="assign-tooltip" tooltipPosition="top" [pTooltip]="showToolTip('price')"
            [escape]="false" [tooltipDisabled]="service.price === part.price">
            <span [class.is-updated]="isFieldUpdated('price')">
              {{renderFieldData(service, 'price') | currency: usd}}
            </span>
          </div>
        </td>

        <!-- Has Core -->
        <!-- <td class="service-next text-truncate font-13 m-0 pr-2">
          <div tooltipStyleClass="assign-tooltip" tooltipPosition="top" [pTooltip]="showToolTip('hasCore')"
            [escape]="false" [tooltipDisabled]="service.hasCore === part.hasCore">
            <span [class.is-updated]="isFieldUpdated('hasCore')">
              {{renderFieldData(service, 'hasCore') | currency: usd}}
            </span>
          </div>
        </td> -->

        <!-- Core Cost -->
        <td class="service-next text-truncate font-13 m-0 px-2 text-right">
          <div tooltipStyleClass="assign-tooltip" tooltipPosition="top" [pTooltip]="showToolTip('coreCost')"
            [escape]="false" [tooltipDisabled]="service.coreCost === part.coreCost">
            <span [class.is-updated]="isFieldUpdated('coreCost')">
              {{renderFieldData(service, 'coreCost') | currency: usd}}
            </span>
          </div>
        </td>

        <!-- Qty -->
        <td class="service-next text-truncate font-13 m-0 px-2 text-right">
          <div class="text-align-right" tooltipStyleClass="assign-tooltip" tooltipPosition="top"
            [pTooltip]="showToolTip('count')" [escape]="false" [class.is-updated]="isFieldUpdated('count')">
            <span>{{renderFieldData(service, 'count') | number : '1.2-2'}}</span>
          </div>
        </td>

        <!-- Sub total -->
        <td class="service-next text-truncate font-13 m-0 px-2 text-right">
          <div class="text-align-right" tooltipStyleClass="assign-tooltip" [pTooltip]="showToolTip('subTotal', service)"
            [escape]="false" tooltipPosition="top">
            <span>{{renderFieldData(service, 'subTotal') | currency: usd}}</span>
          </div>
        </td>
      </tr>
    </div>
  </div>

  <div class="update-canned-service-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="closeDialog(null)">Cancel</button>
    <button class="btn btn-primary btn-submit" [disabled]="isSubmitting" (click)="onSubmit()">
      Save
      <i class="fal fa-spinner rotate" *ngIf="isSubmitting"></i>
    </button>
  </div>
</div>
